// 绑定智慧服务终端
const serviceTerminal = {
    state: {
        terminalId: undefined,
        terminalLocation : undefined
    },

    mutations: {
        SET_SERVICETERMINAL_INFO: (state, params) => {
            state.terminalId = params.terminalId;
            state.terminalLocation = params.terminalLocation;
        },
        SET_SERVICETERMINAL_LOGOUT: (state) => {
            state.terminalId = undefined;
            state.terminalLocation = undefined;
        }
    }
}

export default serviceTerminal